import { Input } from "@/shared/components";
import { RowData, Table } from "@tanstack/react-table";
import type { DataTableFeatures } from "./data-table-features";

export type ColumnTextFilter = {
    column: string;
    placeholder: string;
    defaultValue?: string;
};

type DataTableColumnTextFilterProps<TData extends RowData> = {
    table: Table<DataTableFeatures, TData>;
    column: string;
    placeholder?: string;
};

export function DataTableColumnTextFilter<TData extends RowData>({ table, column, placeholder }: DataTableColumnTextFilterProps<TData>) {
    return (
        <Input
            placeholder={placeholder ?? `Zoek op ${column}...`}
            value={(table.getColumn(column)?.getFilterValue() as string) ?? ""}
            onChange={(event) => table.getColumn(column)?.setFilterValue(event.target.value)}
            className="w-auto"
        />
    );
}
